/**
 * @name Validate
 * @description Componente de botónes solicitud de cambio de puesto
 * @author Alexis Becerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { MUI } from 'styles';

const Validate = (props) => {
  const {
    // Propiedades
    flagResults,
    myShedule,
    isSupervisor,

    // Funciones
    onApprove,
    onReject
  } = props;

  return (
    <>
      {(flagResults && isSupervisor && !myShedule) && (
        <>
          <BoxActions>
            <MUI.ButtonCTA type="button" color="secondary" onClick={() => onReject()}>
              <Trans>DialogConfirm.reject</Trans>
            </MUI.ButtonCTA>
            <MUI.ButtonCTA type="button" color="primary" onClick={() => onApprove()} >
              <Trans>DialogConfirm.approve</Trans>
            </MUI.ButtonCTA>
          </BoxActions>
        </>
      )}
    </>
  );
};

Validate.propTypes = {
  // Boolean que indica si es supervisor.
  isSupervisor: PropTypes.bool.isRequired,
  // Boolean que indica si es horario propio
  myShedule: PropTypes.bool.isRequired,
  // Función que se ejecuta cuando se aprueban el horario.
  onApprove: PropTypes.func.isRequired,
  // Función que se ejecuta cuando se rechazan el horario.
  onReject: PropTypes.func.isRequired,
}


// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default Validate;